export default "__VITE_ASSET__GskJcKBb__"